<template>
  <v-row>
    <v-col>
      <v-autocomplete
        :items="places"
        item-value="short_name"
        :item-text="item => `(${item.short_name}) ${item.stop_name}`"
        :filter="
          (item, query) =>
            item.short_name.toLowerCase().includes(query.toLowerCase()) ||
            item.stop_name.toLowerCase().includes(query.toLowerCase())
        "
        outlined
        label="Plats från"
        v-model="model.from"
      />
    </v-col>
    <v-col>
      <v-autocomplete
        :items="places"
        item-value="short_name"
        :item-text="item => `(${item.short_name}) ${item.stop_name}`"
        :filter="
          (item, query) =>
            item.short_name.toLowerCase().includes(query.toLowerCase()) ||
            item.stop_name.toLowerCase().includes(query.toLowerCase())
        "
        outlined
        label="Plats till"
        v-model="model.to"
      />
    </v-col>
  </v-row>
</template>

<script>
import { get, sync } from 'vuex-pathify'
import { validTime, required } from '@/common/validationRules'

export default {
  name: 'CrewLocationFields',

  data: () => ({
    required,
    validTime,
    time: null
  }),

  computed: {
    stops: get('event/stops'),
    model: sync('crew/model'),
    advertisedPlaces: get('crew/advertisedPlaces'),

    places() {
      return this.advertisedPlaces.length ? this.advertisedPlaces : this.stops
    }
  }
}
</script>
